import { Route } from "react-router-dom";
import { AcademyChapter } from "./components/AcademyChapter";
import { AcademyRoute } from "./components/AcademyRoute";
import { AcademySlides } from "./components/AcademySlides";
import { RentmatchAcademy } from "./RentmatchAcademy";
import {
  ACADEMY_ROUTE,
  ACADEMY_SHORT_PATH,
} from "./RentmatchAcademy.constants";

export const getRentmatchAcademyScene = () => (
  <Route path={ACADEMY_ROUTE} element={<AcademyRoute />}>
    <Route path={ACADEMY_SHORT_PATH} element={<AcademySlides />} />

    <Route path=":chapterId" element={<AcademyChapter />} />

    <Route index element={<RentmatchAcademy />} />
  </Route>
);
